/**
 * vasotopia-pro-tarifs.js — VERSION B2C (campagne pubs Meta, oct. 2026)
 * Bandeau paliers dégressifs GRAND PUBLIC sur la page /cart.
 * ⚠️ L'ancienne version redirigeait vers /discount/PRO6… (codes morts) — SUPPRIMÉ.
 * Les remises automatiques Shopify (2+/3+/5+) s'appliquent seules, aucun code.
 * Détection mini vase : handle commençant par "mini-vase-".
 */
(function () {
  'use strict';

  var TIERS = [
    { min: 5, price: 9.00,  pct: '-36 %' },
    { min: 3, price: 10.00, pct: '-29 %' },
    { min: 2, price: 12.00, pct: '-14 %' }
  ];
  var FREE_SHIPPING = 40;

  function isMiniVase(item) {
    return item.handle && item.handle.indexOf('mini-vase-') === 0;
  }
  function countMiniVases(items) {
    return items.reduce(function (n, item) {
      return isMiniVase(item) ? n + item.quantity : n;
    }, 0);
  }
  function getTier(qty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (qty >= TIERS[i].min) return TIERS[i];
    }
    return null;
  }
  function getNextTier(qty) {
    for (var i = TIERS.length - 1; i >= 0; i--) {
      if (qty < TIERS[i].min) return TIERS[i];
    }
    return null;
  }
  function fmt(n) {
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  function run() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty  = countMiniVases(cart.items);
        var tier = getTier(qty);
        renderBanner(qty, tier, cart.total_price / 100);
      })
      .catch(function () {});
  }

  function renderBanner(qty, tier, cartTotal) {
    var existing = document.getElementById('vtp-pro-banner');
    if (existing) existing.remove();
    if (qty === 0) return;

    var next = getNextTier(qty);
    var html = '';

    if (tier) {
      html += '<div class="vtp-row vtp-active">';
      html += '<span class="vtp-ic">✓<\/span>';
      html += '<span class="vtp-txt">Réduction active : <strong>' + fmt(tier.price) + '\/vase<\/strong> (' + tier.pct + ') · ' + qty + ' mini vase' + (qty > 1 ? 's' : '') + '<\/span>';
      html += '<\/div>';
    }
    if (next) {
      var diff = next.min - qty;
      html += '<div class="vtp-row vtp-next">';
      html += '<span class="vtp-ic">↑<\/span>';
      html += '<span class="vtp-txt">Plus que <strong>' + diff + ' vase' + (diff > 1 ? 's' : '') + '<\/strong> pour passer à <strong>' + fmt(next.price) + '\/vase<\/strong><\/span>';
      html += '<\/div>';
    }
    if (cartTotal > 0 && cartTotal < FREE_SHIPPING) {
      html += '<div class="vtp-row vtp-ship">';
      html += '<span class="vtp-ic">🚚<\/span>';
      html += '<span class="vtp-txt">Plus que <strong>' + fmt(FREE_SHIPPING - cartTotal) + '<\/strong> pour la <strong>livraison offerte<\/strong><\/span>';
      html += '<\/div>';
    } else if (cartTotal >= FREE_SHIPPING) {
      html += '<div class="vtp-row vtp-active">';
      html += '<span class="vtp-ic">🚚<\/span>';
      html += '<span class="vtp-txt"><strong>Livraison offerte<\/strong> — votre panier dépasse ' + FREE_SHIPPING + ' €<\/span>';
      html += '<\/div>';
    }

    var banner = document.createElement('div');
    banner.id = 'vtp-pro-banner';
    banner.innerHTML = html;

    if (!document.getElementById('vtp-pro-style')) {
      var s = document.createElement('style');
      s.id = 'vtp-pro-style';
      s.textContent = '#vtp-pro-banner{font-family:inherit;margin:0 0 18px;border-radius:10px;overflow:hidden;font-size:14px;line-height:1.5}' +
        '#vtp-pro-banner .vtp-row{display:flex;align-items:flex-start;gap:10px;padding:11px 16px}' +
        '#vtp-pro-banner .vtp-active{background:#eef7f0;border-left:4px solid #3d7a4f;color:#2a4d36}' +
        '#vtp-pro-banner .vtp-next{background:#fff8f0;border-left:4px solid #d9967e;color:#5a3028}' +
        '#vtp-pro-banner .vtp-ship{background:#f0f6ff;border-left:4px solid #6a90cc;color:#2a3a5a}' +
        '#vtp-pro-banner .vtp-ic{flex-shrink:0;font-size:16px;margin-top:1px}' +
        '#vtp-pro-banner .vtp-txt{flex:1}' +
        '#vtp-pro-banner strong{font-weight:700}';
      document.head.appendChild(s);
    }

    var anchor =
      document.querySelector('.cart__items') ||
      document.querySelector('form[action="\/cart"]') ||
      document.querySelector('main') ||
      document.body;
    anchor.insertBefore(banner, anchor.firstChild);
  }

  function init() {
    if (window.location.pathname !== '/cart') return;
    run();
    document.addEventListener('cart:refresh',  run);
    document.addEventListener('cart:updated',  run);
    document.addEventListener('cart:rendered', run);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t && t.closest && t.closest('[data-cart-item], .cart__item, cart-items')) {
          run(); break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
